import { type RouteObject } from 'react-router'

import { SHARE_PROJECT } from 'features/share/paths'
import { lazyComponent } from 'routes/lazy-route'

export const shareRoutes: RouteObject[] = [
  {
    path: SHARE_PROJECT,
    lazy: lazyComponent(() => import('features/share/Container'), 'SharePage'),
  },
]
